import React from "react";
import { Box, Flex, VStack, Text, Heading } from "@chakra-ui/react";
import CountUp from "react-countup";

const achievements = [
  { label: "MW+ Engineered", value: 1000 },
  { label: "Happy Clients", value: 150 },
  { label: "Countries", value: 10 },
  { label: "C&I Projects", value: 1500 },
  { label: "Residential Sites", value: 20000 },
];

export default function AchievementsBox() {
  return (
    <Box bg="#F5FAF6" py={16} px={{ base: 4, md: 20 }}>
      <Box bg="white" p={10} rounded="2xl" shadow="xl" textAlign="center">
        <Heading color="#519C36" mb={10} fontSize={{ base: "2xl", md: "5xl" }}>
          HoriSun Milestones
        </Heading>
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-around"
          align="center"
          gap={8}
          wrap="wrap"
        >
          {achievements.map((item, idx) => (
            <VStack
              key={idx}
              spacing={2}
              w={{ base: "full", md: "auto" }}
              bg="#305D24" // Dark greenish background
              p={6}
              rounded="xl"
              shadow="lg"
            >
              <Heading fontSize={{ base: "3xl", md: "5xl" }} color="white">
                <CountUp
                  start={0}
                  end={item.value}
                  duration={3}
                  delay={idx * 0.3}
                  separator=","
                />
                +
              </Heading>
              <Text
                fontSize={{ base: "md", md: "xl" }}
                color="white"
                fontWeight="semibold"
              >
                {item.label}
              </Text>
            </VStack>
          ))}
        </Flex>
      </Box>
    </Box>
  );
}
